<template>
<div class="chapter">
<div class="inner_page">
<p class="epigraph"><a id="page_ix"></a><em>After sleep, after amnesia, after inhabiting different worlds, I no longer know what truth there is in memory. I believe things I didn’t believe before. About what is outside us. About what is inside. It is a new geography, that of the forgetting body and mind, the remembering spirit, a new landscape.</em></p>
<p class="attribute">—<span class="small">LINDA HOGAN, <em>THE WOMAN WHO WATCHES OVER THE WORLD: A NATIVE MEMOIR</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292799325_08_fm2.vue?a9239a58